const API_BASE = window.location.port === '3000'
  ? 'http://localhost:4100/api'
  : window.location.pathname.startsWith('/cmbs')
    ? '/cmbs/api'
    : '/api';

export async function apiFetch(path, options = {}) {
  const token = localStorage.getItem('cmbs_token');
  const headers = { ...options.headers };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (options.body && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
    options.body = JSON.stringify(options.body);
  }

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || `Request failed: ${res.status}`);
  }

  return data;
}

export function login(email, password) {
  return apiFetch('/auth/login', { method: 'POST', body: { email, password } });
}

export function getMe() {
  return apiFetch('/auth/me');
}

export function getDeals(filters = {}) {
  const params = new URLSearchParams(filters).toString();
  return apiFetch(`/deals${params ? `?${params}` : ''}`);
}

export function getDeal(id) {
  return apiFetch(`/deals/${id}`);
}

export function createDeal(deal) {
  return apiFetch('/deals', { method: 'POST', body: deal });
}

export function updateDeal(id, fields) {
  return apiFetch(`/deals/${id}`, { method: 'PUT', body: fields });
}

export function updateDealStatus(id, status, workflow_step) {
  return apiFetch(`/deals/${id}/status`, { method: 'PUT', body: { status, workflow_step } });
}

export function parseEmail(email_body) {
  return apiFetch('/intake/parse-email', { method: 'POST', body: { email_body } });
}

export function pipeToDMP(deal) {
  return apiFetch('/intake/pipe-to-dmp', { method: 'POST', body: deal });
}

export function uploadFiles(dealId, files, fileType) {
  const form = new FormData();
  for (const f of files) form.append('files', f);
  form.append('file_type', fileType);
  return apiFetch(`/extraction/upload/${dealId}`, { method: 'POST', body: form });
}

export function extractData(dealId, fileId) {
  return apiFetch(`/extraction/extract/${dealId}`, { method: 'POST', body: { file_id: fileId } });
}

export function approveExtraction(extractionId) {
  return apiFetch(`/extraction/approve/${extractionId}`, { method: 'POST' });
}

export function getExtractions(dealId) {
  return apiFetch(`/extraction/${dealId}/results`);
}

export function runUnderwriting(dealId, runType, overrides) {
  return apiFetch(`/underwriting/run/${dealId}`, { method: 'POST', body: { run_type: runType, overrides } });
}

export function getAssumptions(propertyType) {
  return apiFetch(`/underwriting/assumptions/${propertyType}`);
}

export function getUnderwritingRuns(dealId) {
  return apiFetch(`/underwriting/${dealId}/runs`);
}

export function searchComps(dealId) {
  return apiFetch(`/comps/search/${dealId}`, { method: 'POST' });
}

export function selectComp(compId, selected) {
  return apiFetch(`/comps/select/${compId}`, { method: 'PUT', body: { selected } });
}

export function getComps(dealId) {
  return apiFetch(`/comps/${dealId}`);
}

export function generateDocument(dealId, docType) {
  return apiFetch(`/documents/generate/${dealId}`, { method: 'POST', body: { doc_type: docType } });
}

export function getDocuments(dealId) {
  return apiFetch(`/documents/${dealId}`);
}

export function approveDocument(docId) {
  return apiFetch(`/documents/approve/${docId}`, { method: 'PUT' });
}

export function uploadQAFile(dealId, file) {
  const form = new FormData();
  form.append('file', file);
  return apiFetch(`/buyer-qa/upload/${dealId}`, { method: 'POST', body: form });
}

export function generateQAAnswers(dealId) {
  return apiFetch(`/buyer-qa/generate/${dealId}`, { method: 'POST' });
}

export function updateQA(qaId, fields) {
  return apiFetch(`/buyer-qa/${qaId}`, { method: 'PUT', body: fields });
}

export function getQA(dealId) {
  return apiFetch(`/buyer-qa/${dealId}`);
}
